/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListDocumentExecutionRequest {
    getFixupPrototypeFunction() { return AwsSsmListDocumentExecutionRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListDocumentExecutionRequest>): AwsSsmListDocumentExecutionRequest {
        let obj = Object.assign(new AwsSsmListDocumentExecutionRequest(), model);
        AwsSsmListDocumentExecutionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListDocumentExecutionRequest>): AwsSsmListDocumentExecutionRequest {
        if (!model) return null;
        return AwsSsmListDocumentExecutionRequest.newInstance(<AwsSsmListDocumentExecutionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListDocumentExecutionRequest) {
        if (!obj) return;

        models.AwsSsmListDocumentExecutionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListDocumentExecutionRequest): boolean {
        Object.setPrototypeOf(obj, AwsSsmListDocumentExecutionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AwsSsmExecutionFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AwsSsmListDocumentExecutionsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AwsSsmListDocumentExecutionsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AwsSsmExecutionFilters;

}
